import React from 'react';
import { FaInstagram, FaYoutubeSquare } from "react-icons/fa";
import GlassCard from '../GlassCard'; // Changed from Card
import './styles.css';

const SocialMedia = ({ isSmall = false }) => {
  return (
    <GlassCard
      className={isSmall ? "social-media-container-small" : "social-media-media-container"} // Renamed class for clarity
      borderRadius="50px" // Pass borderRadius as prop
      hoverEffect={true} // Explicitly enable hover effect
    >
      <a className="social-media-icon" href="https://www.instagram.com/forfunlab" target="_blank" rel="noreferrer">
        <FaInstagram />
      </a>
      <a className="social-media-icon" href="https://www.youtube.com/@forfunlab8049" target="_blank" rel="noreferrer">
        <FaYoutubeSquare />
      </a>
    </GlassCard>
  );
};

export default SocialMedia;
